module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 navigator"
  }, [_c('div', {
    staticClass: "row w-100"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "clickToOpen ml-2 px-2 pointer",
    on: {
      "click": function($event) {
        return _vm.toggleReportList()
      }
    }
  }, [_c('span', {
    staticClass: "fs-largest darkset"
  }, [_vm._v(_vm._s(_vm.selectedAvaliableReport.label))]), _vm._v(" "), _c('i', {
    staticClass: "color-1 large ml-4 pl-2",
    class: {
      'ico-arrow-bottom': !_vm.showReportSelector, 'ico-arrow-top': _vm.showReportSelector
    }
  }), _vm._v(" "), (_vm.showReportSelector) ? _c('ul', {
    staticClass: "selectDrawer bg-lightest p-2 border-medium w-100 radius-normal mt-2"
  }, _vm._l((_vm.avaliableReports), function(option) {
    return _c('li', {
      staticClass: "fs-larger py-1",
      on: {
        "click": function($event) {
          return _vm.selectReport(option)
        }
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row justify-content-end dark fs-largest"
  }, [_vm._v("\n        " + _vm._s(_vm._f("moment")(_vm.dateFrom, 'D MMMM YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.dateTo, 'D MMMM YYYY')) + "\n      ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-dd48ae3e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd48ae3e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/createReport/Navigator.vue
// module id = 1881
// module chunks = 0